import styled from 'styled-components';

/* ----------------------------------
   Why Audit
----------------------------------- */

export const WhyAuditSection = styled.section`
  width: 100%;

  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(280px, 0.9fr);
  gap: var(--space-xxxl);

  align-items: center;

  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: var(--space-xl);
  }
`;

export const WhyAuditContent = styled.div`
  h2 {
    margin: var(--space-xs) 0 var(--space-m);

    color: var(--grey7);

    font-size: clamp(2rem, 3.5vw, 3rem);
    line-height: 1.05;
    font-weight: 900;
    letter-spacing: -0.035em;
  }

  > p:not(.eyebrowHeader) {
    max-width: 700px;

    margin: 0 0 var(--space-m);

    color: var(--grey4);

    font-size: 1rem;
    line-height: 1.8;
  }
`;

export const WhyAuditList = styled.div`
  border-top: 1px solid var(--grey);
`;

export const WhyAuditItem = styled.div`
  padding: var(--space-l) 0;

  display: grid;
  grid-template-columns: 44px minmax(0, 1fr);
  gap: var(--space-m);

  align-items: center;

  border-bottom: 1px solid var(--grey);

  span {
    color: var(--orange5);

    font-size: 0.75rem;
    font-weight: 900;
  }

  p {
    margin: 0;

    color: var(--grey6);

    font-size: 0.92rem;
    line-height: 1.55;
    font-weight: 800;
  }
`;
